/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface GetAbteilungsleiter$Json$Params {
  abteilungId: string;
}

export function getAbteilungsleiter$Json(http: HttpClient, rootUrl: string, params: GetAbteilungsleiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, getAbteilungsleiter$Json.PATH, 'get');
  if (params) {
    rb.path('abteilungId', params.abteilungId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

getAbteilungsleiter$Json.PATH = '/v1/abteilungen/{abteilungId}/leiter';
